import React, { useRef, useEffect, useState } from 'react';
import { useAppSelector } from 'shared/store';
import log from 'shared/utils/log';
import { getIncomingAudioStream } from 'shared/realtime';

/**
 * Plays audio from visitor when no video is coming in. When video comes in,
 * relies on some other video component to play the audio instead.
 */
export const IncomingStreamAudio: React.FC = () => {
  const { isReceivingAudio } = useAppSelector(s => s.realtime);
  const [stream, setStream] = useState<null | MediaStream>(null);
  const audioRef = useRef<null | HTMLVideoElement>(null);

  useEffect(() => {
    const stream = getIncomingAudioStream();
    log.debug(
      `Adding stream to <audio />: ${stream?.getTracks().map(t => {
        return JSON.stringify({
          id: t.id,
          kind: t.kind,
          enabled: t.enabled,
          muted: t.muted,
        });
      })}`,
    );
    setStream(stream);
  }, [isReceivingAudio]);

  useEffect(() => {
    if (stream && audioRef.current && !audioRef.current.srcObject) {
      audioRef.current.srcObject = stream;
      audioRef.current.play().catch(error => {
        log.warn('There was an error trying to play incoming audio', error);
      });
    }
  }, [stream, audioRef]);

  if (!stream) {
    return null;
  }

  return (
    <audio style={{ display: 'none' }} ref={audioRef} autoPlay={false} muted={false} />
  );
};
